import { useState } from 'react'

export type ChatHistoryMessage = {
  from: 'client' | 'server'
  [key: string]: any
}

export const useChatHistory = () => {
  const [messages, setMessages] = useState<ChatHistoryMessage[]>([])

  const addMessage = (message: ChatHistoryMessage) => {
    setMessages((prevHistory) => [...prevHistory, message])
  }

  const addClientMessage = (message: any) => {
    addMessage({ ...message, from: 'client' })
  }

  const addServerMessage = (message: any) => {
    addMessage({ ...message, from: 'server' })
  }

  const clearHistory = () => {
    setMessages([])
  }

  return { messages, addClientMessage, addServerMessage, clearHistory }
}
